// 设置localStorage数据及有效期
export function setItemWithExpiry(key, value,h = 2) {
    // 设置数据，有效期为2小时（单位毫秒）
    let ttl = h * 60 * 60 * 1000
    const now = new Date();
    // ttl (time to live) 以毫秒为单位
    const item = {
        value: value,
        expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
}

// 获取localStorage数据，如果过期了则返回null
export function getItemWithExpiry(key) {
    const itemStr = localStorage.getItem(key);
    // 如果没有找到数据，返回null
    if (!itemStr) {
        return null;
    }
    try {
        const item = JSON.parse(itemStr);
        const now = new Date();
        // 检查有效期
        if (item.expiry != undefined) {
            if (now.getTime() > item.expiry) {
                // 如果过期，删除数据
                localStorage.removeItem(key);
                return null;
            }
        }else {
            return null;
        }
        return item.value;
    } catch (e) {
        return null;
    }
}